import * as api from "./apis/validateEmailAddress";
import { emit, triggerError } from "../utils/eventManager";
import { sendNewRelicEvent } from "../utils/newRelicEvents";
export { validateEmailAddress };
async function validateEmailAddress(email) {
  try {
    sendNewRelicEvent({
      EventName: 'validate_email_start'
    });
    var response = await api.validateEmailAddress(email);
    sendNewRelicEvent({
      EventName: 'validate_email_success'
    });
    emit('validate email address', response);
    return response;
  } catch (e) {
    sendNewRelicEvent({
      EventName: 'validate_email_failed',
      error: e
    });
    triggerError('validate email address', e);
    throw e;
  }
}